import React from "react";
import * as styles from "./toast-notification.module.scss";
import * as globals from "../styles/global.icss.scss";
import IconCheckCircle from "../dynamicicons/icon-check-circle";
import IconError from "../dynamicicons/icon-error";
import IconInfo from "../dynamicicons/icon-info";
import VelavuIconButton from "./velavu-icon-button";
import IconClose from "../dynamicicons/icon-close";
import whitelabel from "../whitelabel";

export type ToastType = "success" | "error" | "info";

export interface ToastNotificationProps {
	type: ToastType;
	title?: string;
	onDismiss?: () => void;
	children?: React.ReactNode;
}

export default function ToastNotification(props: ToastNotificationProps) {
	return (
		<div className={styles.container}>
			<ToastNotificationIcon type={props.type} size={24} />

			<div className={styles.content}>
				{props.title !== undefined && (
					<p className={styles.title}>{props.title}</p>
				)}

				<p className={styles.body}>{props.children}</p>
			</div>

			{props.onDismiss !== undefined && (
				<VelavuIconButton onClick={props.onDismiss} light small>
					<IconClose
						color={whitelabel.palette.secondary700}
						size={24}
					/>
				</VelavuIconButton>
			)}
		</div>
	);
}

function ToastNotificationIcon(props: { type: ToastType; size: number }) {
	switch (props.type) {
		case "success":
			return <IconCheckCircle color={globals.active} size={props.size} />;
		case "error":
			return <IconError color={globals.error} size={props.size} />;
		case "info":
			return <IconInfo color={globals.accent} size={props.size} />;
	}
}
